/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';
import { useHistory } from 'react-router-dom';

import { HubeeDemande } from '@mairistem/administres-utils';

import { baseUrlApp, baseUrlApiHubee } from '@/routes';

const DemandeHubee = () => {
  const history = useHistory();
  const { pathname } = history.location;
  const identifiant = pathname.split('/hubee/')[1];

  const urlRetour = `${baseUrlApp}hubee`;

  return (
    <HubeeDemande
      identifiant={identifiant}
      apiRoute={baseUrlApiHubee}
      urlRetour={urlRetour}
      urlTraitement={`${baseUrlApp}assistant`}
    />
  );
};

export default DemandeHubee;
